import Header from "../../components/Header/Header";
import './ForHome.css'

export default function ForHome(){
    return (
        <div>
            <Header />
            <div className="for-home-container">
                <h1>For Home</h1>
                <h2>Voice Assistant</h2>
                <p>Coming soon—our GPT-powered voice assistant is designed to revolutionize home interactions. Capable of performing a variety of tasks such as giving reminders, 
                    initiating conversations, playing music, and more, this tool will make home automation smarter and more customizable. Stay tuned for a smarter way to interact 
                    with your environment.</p>
            </div>
        </div>
    )
}